import { Component } from "react";
import CircleButton from "../CircleButton";
import {ReactComponent as CloseIC} from "../../../assets/icons/close-ic.svg";

import './style.scss';

class CloseButton extends Component {    

    render() {
        return (
            <>                
                <CircleButton className="close-bt" icon={<CloseIC/>} onClick={this.props.onClick} />
            </>
        )
    }
}

export default CloseButton;